export const environment = {
  url: {
    api: `https://apim-uat.houseofhr.com/square-app-timepartner/api/v2.0`,
  },
  production: true,
  ocpApimSubscriptionKey: '9dc5de8c1eed4c6c8cd6becf8e83de1d'
};

